import React from 'react';
import { AutoComplete as AntdAutoComplete } from 'antd';
import { AutoCompleteProps as AntdAutoCompleteProps } from 'antd/lib/auto-complete';

export interface AutoCompleteProps extends AntdAutoCompleteProps {}

const AutoComplete: React.FC<AutoCompleteProps> = props => {
	// TODO: need to fix Warning: [antd: AutoComplete] `dataSource` is deprecated, please use `options` instead.
	return <AntdAutoComplete {...props} />;
};

export default AutoComplete;
